export default __webpack_public_path__ + "static/media/JoshuaLee.35ccb743.jpg";